import { datadogRum } from '@datadog/browser-rum';
import concealStudentData from '../utils/string';
import  { SET_USER } from '../user/userActions';

const createDataDogMiddleware = (env, version) => {
    datadogRum.onReady(() => {
        datadogRum.init({
            applicationId: '87b68cd6-ad0a-47e1-8505-8288115ad1eb',
            clientToken: 'pub45488306e6b2956a7f09b0fc1ae52700',
            site: 'datadoghq.com',
            service: 'lantern-assessment',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            env,
            forwardErrorsToLogs: true,
            defaultPrivacyLevel: 'mask',
            trackResources: true,
            trackLongTasks: true,
            trackFrustrations: true,
            silentMultipleInit: true,
            version,
            allowedTracingUrls: [/^https:\/\/.*\.amplify\.com/, /^https:\/\/.*\.aws\.wgen\.net/],
            beforeSend: (event) => {
                // remove student name and grade from the tracked event
                if (event.action && event.action.target) {
                    // eslint-disable-next-line no-param-reassign
                    event.action.target.name = concealStudentData(event.action.target.name);
                }
            },
        });
        if (process.env.NODE_ENV !== 'development') {
            datadogRum.startSessionReplayRecording();
        }
    });

    return () => next => action => {
        if (datadogRum) {
            try {
                if (action.type === SET_USER) {
                    datadogRum.setUser({
                        id: action.userId
                    });
                }
                if (action.aquaId) {
                    datadogRum.setGlobalContextProperty('boost', {
                        app_name: 'reading',
                        aqua_id: action.aquaId,
                    });
                }
                if (action.error) {
                    datadogRum.addError(action.error);
                }
            } catch (e) {
                // ignore DD failures
            }
        }
        next(action);
    };
};

export default createDataDogMiddleware;
